<template>
  <div>
    <h4 class="info-text">
      List of Incident associate to Current Investigation
    </h4>
    <div class="row justify-content-center mt-5">
      <div class="col-sm-9">
        <el-table
          :data="tableIncidentList"
          style="border: solid white; border-radius: 10px"
          :header-cell-style="{
            background: 'transparent',
            border: 'none',
            borderBottom: '0.5px solid #3d3f51',
          }"
          :cell-style="{
            border: 'none',
            borderBottom: '0.5px solid #3d3f51',
          }"
        >
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Date of Incident"
            property="dateOfIncident"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Name of Notifier"
            property="notifierName"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Person Involved"
            property="personInvolved"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Type of Incident"
            property="incidentType"
          ></el-table-column>
          <el-table-column :min-width="70" align="right" label="Actions">
            <div slot-scope="props">
              <base-button
                @click="addIncident(props.$index, props.row)"
                type="danger"
                size="sm"
                round
                icon
              >
                <i class="tim-icons icon-simple-delete"></i>
              </base-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <hr style="border-bottom: solid 1px; margin: 1%" />
    <h4 class="info-text">List of Incident Report</h4>
    <div class="row justify-content-center mt-5">
      <div class="col-sm-9">
        <el-table
          :data="tableIncident"
          style="border: solid white; border-radius: 10px"
          :header-cell-style="{
            background: 'transparent',
            border: 'none',
            borderBottom: '0.5px solid #3d3f51',
          }"
          :cell-style="{
            border: 'none',
            borderBottom: '0.5px solid #3d3f51',
          }"
        >
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Date of Incident"
            property="dateOfIncident"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Name of Notifier"
            property="notifierName"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Person Involved"
            property="personInvolved"
          ></el-table-column>
          <el-table-column
            min-width="100"
            sortable
            align="center"
            label="Type of Incident"
            property="incidentType"
          ></el-table-column>
          <el-table-column :min-width="70" align="right" label="Actions">
            <div slot-scope="props">
              <base-button
                @click="minusIncident(props.$index, props.row)"
                round
                icon
                type="green"
              >
                <i class="tim-icons icon-simple-add"></i>
              </base-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn } from "element-ui";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  data() {
    return {
      instid: "",
      tableIncident: [],
      tableIncidentList: [],
      model: {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        address: "",
      },
      removeid: [],
      modelValidations: {
        firstName: {
          required: true,
          min: 5,
        },
        lastName: {
          required: true,
          min: 5,
        },
        email: {
          required: true,
          email: true,
        },
        phone: {
          required: true,
          numeric: true,
        },
      },
    };
  },
  mounted() {
    this.getInstId();
  },
  methods: {
    getInstId() {
      this.$root.$on("instid", (instid) => {
        console.log(instid);
        this.instid = instid;
        this.getIncidents();
      });
    },
    getIncidents() {
      this.tableIncident = [];
      this.tableIncidentList = [];
      this.$http
        .get(":9994/api/v1/incident/inst/" + this.instid)
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            for (var i = 0; i < response.length; i++) {
              let data = {
                instid: response[i].InstId,
                incidentid: response[i].IncidentId,
                dateOfIncident: response[i].DateOfIncident,
                notifierName: response[i].NameOfNotifier,
                personInvolved: response[i].VictimName,
                incidentType: response[i].IncidentType,
                vicKp: response[i].VicKp,
                NoPekerja: response[i].NoPekerja,
                // vicNation: response[i].VicNation,
                // vicSex: response[i].VicSex,
                // vicOccupation: response[i].VicOccupation,
                // vicOrg: response[i].VicComp,
                vicAge: response[i].VicAge,
                vicTelNo: response[i].VicTelNo,
                vicWorkArea: response[i].VicWorkArea,
                vicWorkScope: response[i].VicWorkScope,
                vicSupervisor: response[i].VicSupervisor,
                vicStartDate: response[i].VicStartDate,
                vicHomeAddr: response[i].VicHomeAddr,
                vehRegNo: response[i].VehRegNo,
                vehType: response[i].VehType,
                vehRtaxDate: response[i].VehRtaxDate,
                vehPuspaDate: response[i].VehPuspaDate,
                noOfMc: response[i].NoOfMc,
                noOfLti: response[i].NoOfLti,
                acClassName: response[i].AcClassName,
                acCauseName: response[i].AcCauseName,
                inLocation: response[i].LocDetail,
                // inLocation: response[i].IncidentLocation,
                // inTime: response[i].InTime,
                // inDate: response[i].InDate,
                // vicCompAddr: response[i].VicCompAddr,
                // reportDateToJkkp: response[i].ReportDateToJkkp,
                // inDetail: response[i].InDetail,
                inTime: response[0].IncidentTime,
                // inLocation: response[0].IncidentLocation,
                // medicName: response[i].MedicName,
                // medicDesignation: response[i].MedicDesignation,
                // medicTelNo: response[i].MedicTelNo,
                // medicAddr: response[i].MedicCompAddr,
                // diagnosis: response[i].Diagnosis,
                // diagnosisDate: response[i].DiagnosisDate,
                // doctorName: response[i].DoctorName,
                // doctorAddr: response[i].DoctorAddr,
                weatherCond: response[0].WeatherCond,
                surrCond: response[0].SurrCond,
                injury: response[0].Injury,
                propDamage: response[0].PropDamage,
                inSummry: response[0].InSummary,
                imagefile: response[i].ImageFile,
                imagedesc: response[i].ImageDesc,
                intimestamp: response[i].InTimestamp,
                // image: response[0].InImage
              };
              console.log(this.instid);
              console.log(data.instid);
              // associate incident
              if (this.instid === data.instid) {
                this.tableIncidentList.push(data);
              }
              console.log(this.tableIncidentList);

              // not associate incidents
              // else if(this.instid === ""){
              //   this.tableIncident.push(data)
              // }
              let incidentassociate = this.tableIncidentList;
              this.$root.$emit("associateincident", incidentassociate);
            }
          }
        });

      this.$http.get(":9994/api/v1/incident/incidentnotbound").then((res) => {
        if (!res.error) {
          let response = res.message;

          for (var i = 0; i < response.length; i++) {
            let data = {
              instid: this.instid,
              incidentid: response[i].IncidentId,
              dateOfIncident: response[i].DateOfIncident,
              notifierName: response[i].NameOfNotifier,
              personInvolved: response[i].VictimName,
              incidentType: response[i].IncidentType,
              vicKp: response[i].VicKp,
              NoPekerja: response[i].NoPekerja,
              // vicNation: response[i].VicNation,
              // vicSex: response[i].VicSex,
              // vicOccupation: response[i].VicOccupation,
              // vicOrg: response[i].VicComp,
              vicAge: response[i].VicAge,
              vicTelNo: response[i].VicTelNo,
              vicWorkArea: response[i].VicWorkArea,
              vicWorkScope: response[i].VicWorkScope,
              vicSupervisor: response[i].VicSupervisor,
              vicStartDate: response[i].VicStartDate,
              vicHomeAddr: response[i].VicHomeAddr,
              vehRegNo: response[i].VehRegNo,
              vehType: response[i].VehType,
              vehRtaxDate: response[i].VehRtaxDate,
              vehPuspaDate: response[i].VehPuspaDate,
              noOfMc: response[i].NoOfMc,
              noOfLti: response[i].NoOfLti,
              acClassName: response[i].AcClassName,
              acCauseName: response[i].AcCauseName,
              inLocation: response[i].IncidentLocation,
              // inTime: response[i].InTime,
              // inDate: response[i].InDate,
              // vicCompAddr: response[i].VicCompAddr,
              // reportDateToJkkp: response[i].ReportDateToJkkp,
              // inDetail: response[i].InDetail,
              inTime: response[0].IncidentTime,
              inLocation: response[0].IncidentLocation,
              // medicName: response[i].MedicName,
              // medicDesignation: response[i].MedicDesignation,
              // medicTelNo: response[i].MedicTelNo,
              // medicAddr: response[i].MedicCompAddr,
              // diagnosis: response[i].Diagnosis,
              // diagnosisDate: response[i].DiagnosisDate,
              // doctorName: response[i].DoctorName,
              // doctorAddr: response[i].DoctorAddr,
              weatherCond: response[0].WeatherCond,
              surrCond: response[0].SurrCond,
              injury: response[0].Injury,
              propDamage: response[0].PropDamage,
              inSummry: response[0].InSummary,
              imagefile: response[i].ImageFile,
              imagedesc: response[i].ImageDesc,
              // image: response[0].InImage
            };

            this.tableIncident.push(data);
          }
        }
      });
    },
    minusIncident(index, row) {
      this.tableIncidentList.push(row);
      this.tableIncident.splice(index, 1);
      this.removeid.pop(row.incidentid);
      this.sendAssociateIncident();
      console.log(this.removeid);
      console.log(row.incidentid);
      // console.log(row)
      // console.log(this.instid)
      // tambah
    },

    addIncident(index, row) {
      this.tableIncident.push(row);
      this.tableIncidentList.splice(index, 1);
      this.removeid.push(row.incidentid);
      this.sendAssociateIncident();
      console.log(this.removeid);

      console.log(row.incidentid);
      // let inst = {
      //   instid: row.instid
      // }
      // this.$http.put(":9994/api/v1/incident/removeinstid/"+ parseInt(row.incidentid), inst)
      //   .then(res =>{
      //     if (!res.error){
      //       console.log(res.message)
      //     }
      //   })
      // console.log(row.incidentid)
      // console.log(row)
      // console.log(this.instid)
      // tolak
    },
    sendAssociateIncident() {
      console.log(this.removeid);
      console.log(this.tableIncidentList);
      let incidentassociate = this.tableIncidentList;
      this.$root.$emit("associateincident", incidentassociate);
      let removeinstid = this.removeid;
      this.$root.$emit("remove", removeinstid);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },
  },
};
</script>
<style></style>
